import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f0a590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side" }
const _hoisted_2 = {
  key: 0,
  class: "iconfont icon-onetabAvatar"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"background-color":"rgba(250, 250, 250, 0.4)","opacity":"0.12"}
}, null, -1))
const _hoisted_5 = { class: "canter" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import SettingModal from '@/components/SettingModal.vue';
import AddCategory from '@/components/AddCategory';
import { user } from '@/store/user';
import { RaMessageBox, RaMessage, RaTooltip } from '@rafter/pc';
import { ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
  list: {
    type: Array,
    default: [],
  },
},
  emits: ['change-category'],
  setup(__props, { emit: emits }) {

const props = __props;


const active = ref('');

const showSetting = ref(false);
const showAdd = ref(false);
const settingSelected = ref({
  name: '通用',
  value: 'common',
});
const handleSetting = () => {
  showSetting.value = !showSetting.value;
  console.log(showSetting.value);
  // settingSelected.value.name = '通用';
  // settingSelected.value.value = 'common';
};
watch(
  () => props.list,
  () => {
    if (props.list.length) {
      active.value = props.list[0]?.uuid;
    }
  }
);
const handleAdd = (item) => {
  showAdd.value = true;
};
const handleItem = (item) => {
  if (item.uuid !== active.value) {
    active.value = item.uuid;
    emits('change-category', item);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "avatar",
        onClick: handleSetting
      }, [
        (!_unref(user).token)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _unref(user).avatar
            }, null, 8, _hoisted_3))
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
          return (_openBlock(), _createBlock(_unref(RaTooltip), {
            key: item.uuid,
            placement: "right",
            trigger: "hover",
            content: item.name
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass({ item: true, active: active.value === item.uuid }),
                onClick: ($event: any) => (handleItem(item))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(`side-icon-${item.uuid} iconfont ${item.icon}`)
                }, null, 2)
              ], 10, _hoisted_6)
            ]),
            _: 2
          }, 1032, ["content"]))
        }), 128))
      ]),
      _hoisted_7
    ]),
    (showSetting.value)
      ? (_openBlock(), _createBlock(SettingModal, {
          class: "setting-modal",
          onHandleClose: _cache[0] || (_cache[0] = ($event: any) => (showSetting.value = false)),
          key: "setting",
          selected: settingSelected.value
        }, null, 8, ["selected"]))
      : _createCommentVNode("", true),
    (showAdd.value)
      ? (_openBlock(), _createBlock(_unref(AddCategory), {
          key: 1,
          class: "add-category",
          onHandleClose: _cache[1] || (_cache[1] = ($event: any) => (showAdd.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})